import { render, staticRenderFns } from "./SendModal.vue?vue&type=template&id=6915bd9f"
import script from "./SendModal.vue?vue&type=script&lang=ts"
export * from "./SendModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports